

export const FileSummary = {
  Get: (data: IWorkspaceFileId) => [`get:workspace/file/summary/${data.fileId}`] as const,
  Post: (data: IWorkspaceFileId) => [`post:workspace/file/summary/${data.fileId}`] as const,
};

export const Folder = {
  Base: (data: IWorkspaceFolderId) => `get:workspace/folder/${data.folderId}`,
  Get: (data: IWorkspaceFolderId) => [Folder.Base(data)] as const,
};